import {useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import SearchIcon from '@mui/icons-material/Search';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

import LocatorProductLookup from './LocatorFilterProductLookup';
import LocatorReelTypeLookup from './LocatorFilterReelTypeLookup';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function LocatorFilter(props) {
    //console.debug("RTS Break LocatorFilter");

    const {user} = useSessionContext();

    const [showReelTypeModal, setShowReelTypeModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);

    const [product, setProduct] = useState(props.filter===null?null:props.filter.product);
    const [reelType, setReelType] = useState(props.filter===null?null:props.filter.reelType);
    const [minLength, setMinLength] = useState(props.filter===null?0:props.filter.minLength);
    const [maxAge, setMaxAge] = useState(props.filter===null?0:props.filter.maxAge);
    const [sortBy] = useState(props.filter===null?0:props.filter.sortBy);

    const [showFilter, setShowFilter] = useState(true);


    function setParentFilter(e){
        let args = {"user":user,
                    "product":product==null?null:product, 
                    "reelType":reelType==null?null:reelType,
                    "minLength":minLength,
                    "maxAge":maxAge,
                    "sortBy":sortBy 
                    }
        props.setFilterFx(args);
    }


    function toggleShowFilter()
    {
        setShowFilter(!showFilter);
    }


    function setProductVal(pValue){
        setProduct(pValue);
        setShowProductModal(false);
    };
    
    
    function clearProduct(){
        setProduct(null);
        setShowProductModal(false);
    }   

    
    function setReelTypeVal(pValue){
        setReelType(pValue);
        setShowReelTypeModal(false);
    };


    function clearReelType(){
        setReelType(null);
        setShowReelTypeModal(false);
    }    


    return (
        <>
        <Dialog fullWidth={true} maxWidth="md" open={showProductModal} onClose={()=>{setShowProductModal(false);}}>
            <DialogTitle>Product</DialogTitle>
            <DialogContent>
                <Box>
                    <LocatorProductLookup product={product} setProductValFx={setProductVal} clearValueFx={clearProduct} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowProductModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>         
        <Dialog open={showReelTypeModal} fullWidth={true} maxWidth="md" onClose={()=>{setShowReelTypeModal(false);}}>
            <DialogTitle>Select Reel Type</DialogTitle>
            <DialogContent>
                <LocatorReelTypeLookup data={reelType} setReelTypesFx={setReelTypeVal} clearValueFx={clearReelType} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowReelTypeModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog> 
        <Box sx={{pt:1}}>
            <Box sx={{visibility:showFilter===true?"visible":"hidden", display:showFilter===true?"initial":"none"}}>
                <Grid container id="gridContainer">
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, mt:1}}>
                        <Box id="Product" sx={{display:'flex', alignItems:'center'}}>
                            <TextField
                                id="tbProduct"
                                margin="small"
                                fullWidth
                                label="Product"
                                size="small"
                                value={product==null?'':product.name + " (" + product.idSap + ")"}
                                onClick={setShowProductModal}
                            />
                            <Box sx={{ml:1}}>            
                                <Button variant="contained" onClick={setShowProductModal}>
                                    <SearchIcon sx={{fontSize:'2em'}} />
                                </Button>
                            </Box>            
                        </Box> 
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, mt:1}}>
                        <Box id="ReelType" sx={{display:'flex', alignItems:'center', width:'100%'}}>
                            <TextField
                                id="tbReelType"
                                margin="small"
                                fullWidth
                                label="ReelType"
                                size="small"
                                value={reelType==null?'':reelType.name}
                                onClick={setShowReelTypeModal}
                            />
                            <Box sx={{ml:1}}>            
                                <Button variant="contained" onClick={setShowReelTypeModal}>
                                    <SearchIcon sx={{fontSize:'2em'}} />
                                </Button>
                            </Box>            
                        </Box>  
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbMinLength"
                            margin="none"
                            fullWidth
                            label="Minimum Length Remaining (ft)"
                            type="number"
                            size="small"
                            value={minLength}
                            onChange={(e) => {setMinLength(e.target.value);}}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbMaxAge"
                            margin="none"
                            fullWidth
                            label="Maximum Age (days)"
                            type="number"
                            size="small"
                            value={maxAge}
                            onChange={(e) => {setMaxAge(e.target.value);}}
                        />
                    </Grid>


                    <Grid item xs={12} sx={{px:1, pt:1}}>
                        <Grid container>
                            <Grid item xs={12} sm={6} lg={6} sx={{textAlign:{xs:'center', sm:'left'}}}>
                                <Button type="button" variant="contained" onClick={setParentFilter} sx={{mt:1}} >
                                    <SearchIcon />
                                    <Typography sx={{ml:1}}>Find</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>                        
                </Grid>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleUpOutlinedIcon />} size="small">Hide Filters</Button>
                </Box>                
            </Box>
            <Box sx={{visibility: showFilter===true?"hidden":"visible", display:showFilter===true?"none":"initial"}}>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleDownIcon />} size="small">Show Filters</Button>
                </Box>
            </Box>                     
        </Box>
        </>
    );
}
